module.exports = __webpack_public_path__ + "static/img/ksy.8e7047a7.atlas";